<template>
  <div class="sticky top-0 overflow-x-scroll">
  <div class="flex flex-row">
  <div class="   hover:bg-yellow-400 rounded-lg mr-1"
      v-for="category in this.menu" 
      :id="category.id"
      :key="category.id"
      @click="selectcat">
    <button id="'btn'+category.id"
                class="text-white py-3 px-3 mt-1  text-sm rounded-lg bg-yellow-500 "
                :class="[this.selectedcat==category.id ? 'bg-yellow-600 ' : '']">
      {{ category.name }}
    </button>

  </div>
</div>
</div>
  <section>
  <div class="flex overflow-scroll">
          <SubMenuCard v-for="subMenu in this.subMenuList.subMenus" 
          :id="subMenu.name" :key="subMenu.name" :subMenu="subMenu" @click="selectsubcat" :CurrentSubMenu="this.selectedsubcat"/>
  </div>
  <HorizontalFoodCard
            v-for="product in  this.productList"
            :key="product.id"
            :product="product"
            :baseurl="this.baseurl"
            @showImg="showFullScreenImage(product.imgurl)"/>
  </section>
  
  <!--<TabGroup :defaultIndex="0" v-if="menu.length > 0">
    <TabList class="flex justify-between p-4">
      <Tab v-slot="{ selected }"
           v-for="category in menu"
           :key="category.id">
        <router-link :to="`/shop/${this.$store.state.slug}/menu/${category.screenMenu.id}/${category.id}`"
                     class="text-white py-1 px-2 text-sm rounded-lg"
                     :class="[selected ? 'bg-yellow-500' : '']">
          {{ category.name }}
        </router-link>
      </Tab>
    </TabList>

    <TabPanels>
      <TabPanel v-for="category in menu"
                :key="category.id" class="bg-white-700">

        <div class="flex overflow-scroll">
          <SubMenuCard v-for="subMenu in category.subMenus"
                       :key="subMenu.name" :subMenu="subMenu"/>
        </div>
        <router-view></router-view>
       

      </TabPanel>
    </TabPanels>
  </TabGroup>
  -->
</template>

<script>
//import {Tab, TabGroup, TabList, TabPanel, TabPanels} from '@headlessui/vue'
//import {getMenu} from "@/API/API";
import SubMenuCard from "@/components/SubMenuCard";
import HorizontalFoodCard from "@/components/HorizontalFoodCard";
import store from '../store';
//import route from '../router';
import {getLanguagesbymenu,getMenu,getCatMenu/*,getLanguages*/,getAllLanguages} from "@/API/API";

//import HorizontalFoodCard from "@/components/HorizontalFoodCard";

export default {
  name: 'menun1',

  components: {
    SubMenuCard,
    HorizontalFoodCard,
    //TabGroup,
    //TabList,
    //Tab,
    //TabPanels,
    //TabPanel,
  },
  data() {
    return {
      menu: [],
      subMenuList:[],
      productList:[],
      selectedcat:0,
      baseurl:'',
      selectedsubcat:"",
    }
  },

  setup() {
      
    //const 1 = ref(null)



    },
  async created() {
    //console.log('10');
    
    //console.log(templanguages[this.$store.state.deflange]);
    //console.log(product.imgurl);
    this.baseurl=process.env.VUE_APP_APIDOMAIN;
    
    //console.log(store.state.slug);
    var shopslug=this.$route.params.slug;//value.match(new RegExp("/store/" + "(.*)" + "/menu"));
    //let shopslug = route.currentRoute.value.substring(route.currentRoute.value.indexOf("/store/") + 1,route.currentRoute.value.lastIndexOf("/menu"));
    store.commit('SET_SLUG',shopslug );
    //console.log(this.$store.state.deflange);
      if(this.$store.state.deflange===null || this.$store.state.deflange==="")
         store.commit('SET_DEFLANGE',1);
    //this.menu = (await getMenu(this.$store.state.slug,1)).data
    //console.log(this.menu[0].id);
    //if (Object.keys(this.menu).length === 0)
    //console.log((await getLanguagesbymenu(shopslug,this.$route.params.id)).data);
    let templanguages=(await getLanguagesbymenu(shopslug,this.$route.params.id)).data//
    //let Allaln=(await getLanguages(shopslug)).data
    let Allaln=(await getAllLanguages()).data
    //console.log(templanguages);
    //console.log('2002');
    store.commit('SET_LANGES',JSON.parse(JSON.stringify(templanguages)) );
    //console.log(Allaln);
    //console.log(this.$store.state.deflange);
    this.$i18n.locale=Allaln[this.$store.state.deflange-1].name;
    //console.log(20);
    //console.log(this.$route.params.slug);
    //console.log(this.$route.params.id);
    //console.log(this.$store.state.deflange);
    
    //console.log(21);
    //console.log((await getMenu(this.$route.params.slug,this.$route.params.id,this.$store.state.deflange)));
    this.menu = (await getMenu(this.$route.params.slug,this.$route.params.id,this.$store.state.deflange)).data;
    //console.log(this.menu);
    //this.menu = (await getCatMenu(this.$route.params.slug,this.$route.params.id,null)).data;
    this.selectedcat=this.menu[0].id;
    this.subMenuList=this.menu.filter(x=>x.id==this.selectedcat)[0];
    this.productList=this.subMenuList.products;
    //console.log(this.menu[0].id);
    //console.log(this.subMenuList);
    //console.log(this.subMenuList.products);
    
    //this.$id.${this.selectedcat}.click();
    //this.$router.push(`/shop/${this.$store.state.slug}/menu/${this.$route.params.id}/${this.menu[0].id}`) 
    //console.log(this.selectedcat);
    //console.log(this.subMenuList);

    

  },

  methods: {
    isChooseFood() {
      return false;//this.$route.matched.some(record => record.name === 'ChooseFood');
    },
     selectcat: async function (event) {
      this.selectedcat= event.currentTarget.id;
      this.menu = (await getCatMenu(this.$route.params.slug,this.$route.params.id,this.selectedcat,this.$store.state.deflange)).data;
      //console.log(this.menu);
      this.subMenuList=this.menu.filter(x=>x.id==this.selectedcat)[0];
      //console.log(this.subMenuList);
      //console.log(this.menu);
      this.productList=this.subMenuList.products;
      //console.log(this.menu.filter(x=>x.id==this.selectedcat)[0]);
      //console.log(this.subMenuList);
      //console.log(this.subMenuList);
    },
    selectsubcat: async function (event) {
      this.selectedsubcat= event.currentTarget.id;
      //console.log(113);
      //console.log(this.selectedsubcat);
      //console.log(this.subMenuList);
      //console.log(this.subMenuList.products);
      //console.log(114);
      this.subMenuList=this.menu.filter(x=>x.id==this.selectedcat)[0];
      this.productList=this.subMenuList.products.filter(x=>x.subMenuTagList.includes(this.selectedsubcat));
      //this.menu = (await getSubMenu(this.$route.params.slug,this.$route.params.id,this.selectedcat,this.selectedsubcat)).data.result;
      //this.subMenuList=this.menu.filter(x=>x.id==this.selectedcat)[0];
      //console.log(this.menu.filter(x=>x.id==this.selectedcat)[0]);
      //console.log(this.subMenuList);
      //console.log(this.subMenuList);
    },
  },
  /*computed:
    {
        filters(){
            return{
              subMenuInstance:this.menu.filter(x=>x.id===this.selectedcat),
            };
        }
    },*/
  watch: {
    
    '$route'() {
      ///if (this.$route.name === 'Menu') {
      //  console.log('5');
        // Load the First Menu as Default
      //  this.$router.push(`/shop/${this.$store.state.slug}/menu/${this.$route.params.id}/${this.menu[0].id}`)
      //}
    }
  }
}
</script>
